import { render, staticRenderFns } from "./ArticleSell.vue?vue&type=template&id=3b0dd0ca"
import script from "./ArticleSell.vue?vue&type=script&lang=js"
export * from "./ArticleSell.vue?vue&type=script&lang=js"
import style0 from "./ArticleSell.vue?vue&type=style&index=0&id=3b0dd0ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports